import { Card } from "@mui/material";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

function MaintenanceStats({ title, value, subtitle, icon, color }) {
  return (
    <Card>
      <VuiBox p={2.5} display="flex" justifyContent="space-between" alignItems="center">
        <VuiBox>
          <VuiTypography variant="caption">{title}</VuiTypography>

          <VuiTypography variant="h4" fontWeight="bold">
            {value}
          </VuiTypography>

          {subtitle && <VuiTypography variant="caption">{subtitle}</VuiTypography>}
        </VuiBox>

        <VuiBox
          width="45px"
          height="45px"
          borderRadius="12px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{
            background: `${color}20`,
            color,
          }}
        >
          {icon}
        </VuiBox>
      </VuiBox>
    </Card>
  );
}

export default MaintenanceStats;
